/** Cài đặt chấm điểm hội thoại của doanh nghiệp (BE: POST /chatbot/ai/scoresettings, BusinessSettings type 41). */
export type AiScoreVisibility = 'managers' | 'own' | 'all';

export const AI_SCORE_VISIBILITIES: AiScoreVisibility[] = ['managers', 'own', 'all'];

/** Cách khớp câu chốt phiên (khớp BE ScoreSettingsService::CLOSING_*). */
export type AiScoreClosingMatch = 'contains' | 'exact';
export const AI_SCORE_CLOSING_MATCHES: AiScoreClosingMatch[] = ['contains', 'exact'];

/** 1 = thứ Hai … 7 = Chủ nhật (ISO-8601, giống date('N') bên BE). */
export const AI_SCORE_WEEK_DAYS = [1, 2, 3, 4, 5, 6, 7] as const;

export interface IAiScoreCriterion {
  key: string;
  name: string;
  /** Mô tả cho AI: hướng dẫn chấm, nên kèm khi nào Đạt, khi nào Không đạt, khi nào N/A. */
  guide: string;
  scale: 'binary' | '0-3';
  /** 1-10 */
  weight: number;
  /** Rớt tiêu chí Quan trọng thì cả phiên Không đạt. */
  critical: boolean;
  /** machine: tính từ dữ liệu (phản hồi lần đầu), không gọi AI. */
  source: 'ai' | 'machine';
  enabled: boolean;
}

export interface IAiScoreWorkingHours {
  /** Bật thì bỏ phiên nằm hoàn toàn ngoài giờ và không tính thời gian chờ ngoài giờ. */
  enabled: boolean;
  days: number[];
  /** HH:MM */
  from: string;
  to: string;
}

export interface IAiScoreSettings {
  /** Trợ lý dùng để chấm (tài khoản và model); trống = theo trợ lý gợi ý của page. */
  assistantId: string;
  passThreshold: number;
  visibility: AiScoreVisibility;
  /** Nhân viên chỉ thấy Đạt/Không đạt, không thấy điểm số. */
  staffHidePercent: boolean;
  responseTargetMinutes: number;
  criteria: IAiScoreCriterion[];
  /** Không phân biệt hoa thường, dấu, dấu câu; không có biến hay từ khoá. */
  closingPhrases: string[];
  /** Tin của shop có chứa nguyên câu chốt (mặc định) hoặc trùng cả câu. BE cũ chưa trả = có chứa. */
  closingMatch?: AiScoreClosingMatch;
  workingHours: IAiScoreWorkingHours;
  /** Tối đa phiên tự chấm mỗi ngày của cả doanh nghiệp (BE mặc định 200); 0 = không giới hạn. */
  autoDailyLimit: number;
  /** Tự chấm chung cho mọi page chưa cài riêng (tab Theo doanh nghiệp). BE cũ chưa trả = tắt. */
  auto?: IAiScorePageAuto;
  version: number;
  updatedAt: number;
  updatedBy: string;
}

/** Giới hạn phiên tự chấm mỗi ngày của doanh nghiệp (khớp BE ScoreSettingsService): tự nhập từ 1, 0 = không giới hạn. */
export const AI_SCORE_AUTO_DAILY_LIMIT = { min: 1, default: 200, unlimited: 0 } as const;
/** Hết phiên khi khách im lặng (phút) và tỉ lệ phiên được tự chấm, giống cài đặt aiScore của page bên BE. */
export const AI_SCORE_SESSION_GAPS = [30, 60, 120, 240, 360] as const;
export const AI_SCORE_SAMPLE_RATES = [10, 20, 50, 100] as const;
/** Cài riêng của page (aiScore.custom, aiScope.custom): 1 riêng, 2 theo doanh nghiệp. */
export const AI_PAGE_CUSTOM = { on: 1, off: 2 } as const;

/** Tự chấm điểm (của doanh nghiệp hoặc một page, settings.aiScore); status, onOpen: 1 bật, 2 tắt. */
export interface IAiScorePageAuto {
  status: number;
  sessionGapMinutes: number;
  sampleRate: number;
  onOpen: number;
  /** Chỉ ở page: 1 cài riêng, 2 theo doanh nghiệp. */
  custom?: number;
}

/** Một dòng bảng Tự chấm điểm: page, trợ lý đang gắn (chưa gắn thì không bật được), cài đặt tự chấm. */
export interface IAiScorePageRow {
  pageId: string;
  name: string;
  avatar: string;
  channel: number;
  assistant: { id: string; name: string } | null;
  aiScore: IAiScorePageAuto;
}

/** Đổi tự chấm của page, gửi cùng settings (BE nhận pages là chuỗi JSON). */
export type IAiScorePageUpdate = { pageId: string } & Partial<IAiScorePageAuto>;

export interface IAiScoreSettingsData {
  settings: IAiScoreSettings;
  defaultCriteria: IAiScoreCriterion[];
  assistants: { id: string; name: string; model: string }[];
  limits: { criteria: number; critical: number; closingPhrases: number };
  /** Bảng tự chấm theo page (page có trợ lý lên đầu). */
  pages?: IAiScorePageRow[];
  /** Số phiên đã tự chấm hôm nay của doanh nghiệp. */
  usage?: { autoToday: number };
}
